module.exports = __webpack_public_path__ + "img/thumb_shops_landing_page.ed6004e5.jpg";